export default __webpack_public_path__ + "static/media/15.dec8eea3.jpg";